export enum FETCH_STATUS {
  INTITIAL = 'INTITIAL',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  ERROR = 'ERROR',
}
